export default __webpack_public_path__ + "static/media/noCreditCard.4a644acd.png";